export enum AdiNetworkPagesEnum {
  AllVideosAndArticles = "All Videos And Articles",
  EarnCommissionWithGoShorty = "Earn Commission With GoShorty",
  ReferralScheme = "Referral Scheme",
  CustomerService = "Customer Service",
  TermsAndConditions = "Terms And Conditions",
  FAQs = "FAQs",
}
